import Cookies from "js-cookie";

export const WhiteLinearGradient =
  "bg-gradient-to-br from-white to-primary-white dark:to-primary-midBlack dark:from-primary-black";

export const WhiteLinearGradientDarkPlain =
  "bg-gradient-to-br from-white to-primary-white dark:to-primary-black dark:from-primary-black";

export const BlueLinearGradient =
  "bg-gradient-to-br to-primary-purple from-primary-blue";

export const WhiteTextLinearGradient =
  "text-transparent bg-clip-text bg-gradient-to-br from-white to-primary-white ";

export const BlackTextLinearGradient =
  "text-transparent bg-clip-text bg-gradient-to-r from-primary-lightBlack to-primary-black dark:from-white dark:to-primary-white";

export const BlueTextLinearGradient =
  "text-transparent bg-clip-text bg-gradient-to-br to-primary-purple from-primary-blue dark:from-white dark:to-primary-white";

export const PinkTextLinearGradient =
  "text-transparent bg-clip-text bg-gradient-to-br to-[#F54D46] from-[#FF0000]";

export function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function validateEmail(email) {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
}

export function validPhone(phone) {
  return /^\d+$/.test(phone) && phone.length == 10;
}

export function showInstructionDialog() {
  return Cookies.get("dontShowInstruction") != "true";
}

export function timestampToFormattedDate(timestamp) {
  if (!timestamp) return "";
  const date = new Date(timestamp);
  let monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  let day = date.getDate();

  let monthIndex = date.getMonth();
  let monthName = monthNames[monthIndex];

  let year = date.getFullYear();

  return `${day} ${monthName} ${year}`;
}

export function getExpiresInDays(timestamp) {
  if (!timestamp) return null;
  console.log("getExpiresInDays timestamp: ", timestamp);
  
  // convert timestamp to date
  if (typeof timestamp === "string") {
    timestamp = parseInt(timestamp);
  } else if (typeof timestamp !== "number") {
    console.error("Invalid timestamp type:", typeof timestamp);
    return null;
  }
  const date = new Date(timestamp);
  if (isNaN(date.getTime())) {
    console.error("Invalid date from timestamp:", timestamp);
    return null;
  }
  console.log("getExpiresInDays date: ", date);
  
  const today = new Date();
  console.log("getExpiresInDays today: ", today);
  const timeDiff = date.getTime() - today.getTime();
  console.log("getExpiresInDays timeDiff: ", timeDiff);
  
  const currDate = new Date();
  // if (timeDiff < 0) {
  //   return 0;
  // } else {
  //   return Math.floor(
  //     (date.getTime() - today.getTime()) / (1000 * 3600 * 24)
  //   ) <= 0
  //     ? 0
  //     : Math.floor((date.getTime() - today.getTime()) / (1000 * 3600 * 24));
  // }
}

export function isSubscriptionExpired(timestamp) {
  if (!timestamp) return true;
  const days = getExpiresInDays(timestamp);
  if (days <= 0) return true;
  else return false;
}

export function showQuestionsAnnouncement(user) {
  if (!user || user.answered) return false;
  else return true;
}

export function showTrailExpireAnnouncement(user) {
  if (user && getExpiresInDays(user.expiresAt) <= 10) return true;
  else return false;
}

export function numberToWords(number) {
  if (!number) return "Zero ";
  return number == 0
    ? "Zero"
    : number == 1
    ? "One"
    : number == 2
    ? "Two"
    : number == 3
    ? "Three"
    : number == 4
    ? "Four"
    : number == 5
    ? "Five"
    : number == 6
    ? "Six"
    : number == 7
    ? "Seven"
    : "";
}
